import React from 'react';

import { useDutchiePay } from 'src/payments/hooks';
import useUI from 'src/hooks/use-ui';

import { WhiteLabelLogo } from 'src/payments/components';
import { ExistingUser } from './components/existing-user';
import { NewUser } from './components/new-user';
import { LogosLockup, PayByBankLogo } from './bank-account.styles';

export function BankAccount(): JSX.Element {
  const {
    allowDutchiePayEnrollment,
    isEnrolledDutchiePay,
    isDutchiePayEnabledForDispo,
    whiteLabelConfig,
    shouldShowBankAccountTab,
  } = useDutchiePay();

  const { isDutchieMain } = useUI();
  const shouldDisplaySignUpInfo = !isEnrolledDutchiePay || (!isDutchieMain && !isDutchiePayEnabledForDispo);

  if (!shouldShowBankAccountTab) {
    return <></>;
  }

  return (
    <>
      {(whiteLabelConfig.useWhiteLabel || isDutchiePayEnabledForDispo) && (
        <LogosLockup>
          {whiteLabelConfig.useWhiteLabel ? (
            <WhiteLabelLogo variant='dark' />
          ) : (
            <PayByBankLogo width={109} height={20} />
          )}
        </LogosLockup>
      )}

      {shouldDisplaySignUpInfo ? (
        <NewUser allowDutchiePayEnrollment={isDutchieMain ? true : allowDutchiePayEnrollment} />
      ) : (
        <ExistingUser />
      )}
    </>
  );
}
